var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgIcSend = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m8.507 13.481-.758.254.001.006zm0 4.275-.757-.26-.001.006zm15.211-1.337a.8.8 0 1 0 0-1.6zM7.076 24.726l.343.723zm-.698-.618.759.254zm.354-16.874 18.212 8.65.686-1.445-18.21-8.65zm18.212 8.12-18.212 8.65.687 1.445 18.211-8.65zm-14.947.005-.733-2.137-1.514.519.733 2.137zm-.731-2.132-2.13-6.352-1.516.508 2.129 6.352zm-2.13 11.135 2.13-6.352-1.517-.508-2.13 6.352 1.518.508zm2.128-6.346.733-2.138-1.514-.519-.733 2.138zm-.024-1.597h14.478v-1.6H9.24zm-2.508 7.585a.294.294 0 0 1 .405.358l-1.517-.508c-.366 1.092.758 2.09 1.799 1.595zm18.212-8.12a.294.294 0 0 1 0-.53l.686 1.445c.995-.473.995-1.888 0-2.36zM7.419 5.788c-1.04-.494-2.165.503-1.8 1.595l1.518-.508a.294.294 0 0 1-.405.359z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSend);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };